'use client';

import { LoadingIcon } from '@components/icons/loading';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

export default function LoadingHandler({ children }) {
    const pathname = usePathname();
    const [currentPathname, setCurrentPathname] = useState("");

    useEffect(() => {
        setCurrentPathname(pathname);
    }, [pathname]);

    return (
        <>
            {currentPathname === pathname
                ?
                children
                :
                <LoadingIcon />
            }
        </>
    );
}